import { render, staticRenderFns } from "./Accident.vue?vue&type=template&id=4444ac92"
import script from "./Accident.vue?vue&type=script&lang=js"
export * from "./Accident.vue?vue&type=script&lang=js"
import style0 from "./Accident.vue?vue&type=style&index=0&id=4444ac92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports